/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Img_AltInputs */

const en_fw_guide_img_alt = /** @type {(inputs: Fw_Guide_Img_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satoko Kirigaya and Shinpei Goto in the official Firefly Wedding manga artwork`)
};

const zh_fw_guide_img_alt = /** @type {(inputs: Fw_Guide_Img_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`《萤火之嫁》官方漫画插画中的桐ヶ谷紗都子与後藤進平`)
};

/**
* | output |
* | --- |
* | "Satoko Kirigaya and Shinpei Goto in the official Firefly Wedding manga artwork" |
*
* @param {Fw_Guide_Img_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_img_alt = /** @type {((inputs?: Fw_Guide_Img_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Img_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_img_alt(inputs)
	return zh_fw_guide_img_alt(inputs)
});
export { fw_guide_img_alt as "fw.guide.img_alt" }